import * as React from 'react';
import { MijnFNVHero } from '../widgets/MijnFNVHero';
import { PageRenderHelpers } from './helpers/PageRenderHelpers';
import { PageHelpers } from './helpers/PageHelpers';
import { BaseRelatedViewModel, PageProps } from './interfaces/PageInterfaces';
import { MijnFNVMenu } from '../widgets/MijnFNVMenu';
import { AlertContainer } from '../../containers/AlertContainer';
import { MenuHelpers } from './helpers/MenuHelpers';
import { MijnFNVPageContext } from '../pages/helpers/MijnFNVPageContext';
import { AnimationService, ANIMATION_DASHBOARD_LOADING_CONTEXT } from '../../services/AnimationService';
import { Popup } from './components/popup';
import { MIJNFNV_POPUPS_URL } from '../../constants/Constants';

export class DashboardPage extends React.Component<PageProps> {
    componentDidMount() {
        AnimationService.enableFormAnimations();
        AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);
    }

    componentDidUpdate() {
        this.handleAnimations();
    }

    handleAnimations() {
        AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);
        AnimationService.triggerAnimations();
    }

    renderPopup() {
      const popupModel = this.props.kenticoPage.MijnFnvOverzicht.PopupModel;
      if (!popupModel) {
        return null;
      }

      const popupModelId = popupModel.DocumentID;

      const closePopUp = async () => {
        await fetch(`${MIJNFNV_POPUPS_URL}?documentid=${popupModelId}`, {
          method: 'post'
        });
      };
      
      return <Popup
        opened={true}
        title={popupModel.Titel}
        content={popupModel.Content}
        headerImage={popupModel.HeaderFoto}
        onHide={closePopUp}
        ctaUrl={popupModel.CTAUrl}
        ctaText={popupModel.CTAText}
        formName={popupModel.FormName}
        formDefinition={popupModel.FormDefinition}
        />;
    }

    render() {

        MenuHelpers.showBreadCrumbs();
        MenuHelpers.showMenu();

        this.handleAnimations();

        return <React.Fragment>
            <div className="row">
                <div className="col-12 col-md-1" />
                <div className="col-12 col-md-10">
                    <AlertContainer showSystemAlerts={this.props.kenticoPage.MijnFnvOverzicht.ShowSystemNotifications} />
                </div>
                <div className="col-12 col-md-1" />
            </div>

            <div className="row mijn-fnv__dashboard-page">
                <div className="col-12 col-md-1" />
                <div className="mijn-fnv__sidemenu col-12 col-md-2 mijn-fnv__widget">
                    {MijnFNVMenu(PageHelpers.getSideMenu(this.props.kenticoPage), 
                        this.context.pathname)}
                </div>
                <div className="mijn-fnv__mainBlock col-12 col-md-8">
                    {this.props.kenticoPage.MijnFnvOverzicht.ShowUserRoleLabel && 
                        <h2 className="mijn-fnv__dashboard-page-userrole-title mijn-fnv__widget">{this.props.kenticoPage.MijnFnvOverzicht.UserRoleLabel}</h2>}
                    {MijnFNVHero(this.props.kenticoPage.MijnFnvTopTaken)}
                    {// Get columns with all widgets form the page definition
                    //(right now we simply look at how many widgets and we distribute them over 2 columns)
                    getItemColumns(PageHelpers.getWidgets(this.props.kenticoPage))}
                </div>
                <div className="col-12 col-md-1" />
            </div>
            {this.renderPopup()}
        </React.Fragment>;
    }
}

DashboardPage.contextType = MijnFNVPageContext;

function getItemColumns(widgets: BaseRelatedViewModel[]) {
    const columns = PageHelpers.splitWidgetsToColumns(widgets) || [];

    return (
        <div className="row">
            {columns.map((widgetColumn, index) => (
                <div key={'widgetColumn' + index} className="column col-12 col-md-6">
                    {widgetColumn.list.map((widgetDefinition, index) =>
                        PageRenderHelpers.renderWidget(
                            widgetDefinition,
                            'widget',
                            index,
                            'dashboard'
                        )
                    )}
                </div>
            ))}
        </div>
    );
}
